<template>
    <div class="survey">
        <div class="head">
            <div class="back" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </div>
            <img class="bg" object-fit="contain" src="@/assets/img/apply_bg.png" alt="" srcset=""/>
            <div class="sub">{{$t('business_school.lecturer')}}<br>{{$t('business_school.application')}}</div>
        </div>
        <div class="tips">
            {{$t('business_school.application_process')}}
        </div>
        <van-form :label-width="'100%'" ref="form" @submit="onSubmit">
            <van-cell-group inset>
               <template v-for="(item,index) in topic">
                    <div class="label" style="text-align: left;">
                        <span style="color: red;" v-show="item.isMust == 1">*</span>{{index+1}}.{{ item.itemName }}
                    </div>
                    <van-field :key="index" v-if="item.type===2" :name="item.itemName"  :rules="item.isMust == 1?[{required:`${item.isMust == 1}`,message:`${item.promptText}`}]:[]">
                        <template #input>
                            <van-uploader  v-model="fileList" :max-count="1" :after-read="afterRead(item.itemName)" />
                        </template>
                    </van-field>
                   <van-field :key="index" v-else-if="item.type===3" :name="item.itemName"  :rules="item.isMust == 1?[{required:`${item.isMust == 1}`,message:`${item.promptText}`}]:[]">
                    <template #input>
                        <van-radio-group v-model="form[item.itemName]">
                        <van-radio v-for="e in item.subItemList" :key="e.subItemName" :name="e.subItemName">{{e.subItemName}}</van-radio>
                        </van-radio-group>
                    </template>
                   </van-field>
                   <van-field :key="index" v-else v-model="form[item.itemName]" :name="item.itemName" :placeholder="item.promptText" :rules="item.isMust == 1?[{required: true,message:`${item.promptText}`}]:[]" />
               </template>
            </van-cell-group>
            <div style="margin: 16px;">
                <van-button round type="primary" class="submit" native-type="submit">
                {{$t('text.submit')}}
                </van-button>
            </div>
            </van-form>
    </div>
</template>

<script>
export default {
    name: "cases",
    components: {  },
    data() {
        return {
            fileList: [],
            topic:[],
            form:{}
        }
    },

    computed: {

    },

    watch: {

    },

    mounted() {
        this.getApplyItem()
    },

    methods: {
        getApplyItem() {
            this.$apis.school.getTeacherApplyItemList().then(res =>{
                this.topic = res.data.records.filter(item => item.enable == 1)
            })
        },
        async afterRead(itemName) {
            let formData = new FormData();

            let file
            try {
              file = this.fileList[0].file
            } catch (error) {
              console.log(error);
            }
            if (!file) return

            formData.append("file", this.fileList[0].file);
            //发送给后端
            // formData.append("img_path","h5_img");
            let imagess = await this.$apis.common.uploadImg(formData)
            this.form[itemName] = imagess.data.savedAs
            console.log(this.form);

        },
        onSubmit(form){
            this.$refs.form.validate().then(()=>{

                // if (!this.form.strengths) this.form.strengths = ''
                const params = this.convertFormData(this.form, this.topic)
                this.$apis.school.submitTeacherApply(params).then(res=>{
                    if (res.code == 200) {
                        this.$utils.message(this, this.$t('business_school.applied'));
                        this.$router.go(-1)
                    }else {
                        this.$utils.message(this, this.$t('business_school.fail'));
                    }
                })
            })
        },
        convertFormData(originalData, dynamicItems) {
            // 初始化接口参数结构
            const apiParams = {
                strengths: "",
                itemValueList: []
            };

            // 处理固定字段（如strengths）
            if (originalData.strengths) {
                apiParams.strengths = originalData.strengths;
            }

            // 处理动态字段
            dynamicItems.forEach(item => {
                const fieldName = item.itemName;
                if (originalData[fieldName] !== undefined) {
                apiParams.itemValueList.push({
                    teacherApplyItemId: item.id,
                    teacherApplyItemValue: originalData[fieldName]
                });
                }
            });

            return apiParams;
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.survey {
    background: #fff;
    height: 100%;
    height: 100%;
    overflow: auto;
    font-size: 14px;
    &::-webkit-scrollbar {
        display: none;
    }
    .head{
        width: 100%;
        height: 250px;
        position: relative;
        .back{
            position: absolute;
            height: 50px;
            line-height: 50px;
            top: 0;
            left: 16px;
        }
        .bg{
            width: 100%;
            height: 100%;
        }
        .sub{
            left: 20%;
            top: 55%;
            position: absolute;
            color: #000;
            font-weight: bolder;
            font-size: 30px;
            text-align: left;
        }
    }
    .tips{
        padding: 10px;
        color: #ED4A3C;
        background-color: #fdefef;
        text-align: left;
    }
    .van-cell-group{
        padding: 10px;
        margin: 0;
    }
    .van-cell{
        overflow: auto;
    }
    .label{
        font-weight: bold;
    }
    .van-field__body input{
        padding: 10px;
        border: 1px solid #eee;
        min-height: 40px;
    }
    /* 当表单项处于错误状态时，调整 placeholder 颜色 */
    // /deep/.van-cell--error .van-field__control::placeholder {
    //     color: #323233; /* 红色或其他你希望的错误颜色 */
    // }
    .van-field--error .van-field__control::placeholder{
        color: #c8c8c8; /* 红色或其他你希望的错误颜色 */
    }
    .van-radio__icon,.van-checkbox__icon{
        font-size: 14px;
    }
    .van-radio__label,.van-checkbox__label{
        font-size: 14px;
        line-height: 30px;
    }
    .el-form-item__label{
        font-weight: bold;
    }
    .el-form-item__content{
        line-height: 26px;
    }
    .el-radio-group,.el-checkbox-group{
        text-align: left;
        padding-left: 5px;
        .el-checkbox,.el-radio{
            line-height: 26px;
            font-size: 14px;
        }
    }
    .submit{
        width: 100%;
        background: linear-gradient(#E22F25, #ED4A3C);
        border-radius: 4px;
        padding: 8px 20px;
        font-size: 14px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/survey.vue